/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CustomerTransactionPriceRequestDTO,
  TransactionPriceResultDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getTransactionPrice = (
    customerTransactionPriceRequestDTO: CustomerTransactionPriceRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionPriceResultDTO>(
      {url: `/business/api/v1/transaction-price`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerTransactionPriceRequestDTO, signal
    },
      options);
    }
  


export const getGetTransactionPriceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTransactionPrice>>, TError,{data: CustomerTransactionPriceRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getTransactionPrice>>, TError,{data: CustomerTransactionPriceRequestDTO}, TContext> => {

const mutationKey = ['getTransactionPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTransactionPrice>>, {data: CustomerTransactionPriceRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  getTransactionPrice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetTransactionPriceMutationResult = NonNullable<Awaited<ReturnType<typeof getTransactionPrice>>>
    export type GetTransactionPriceMutationBody = CustomerTransactionPriceRequestDTO
    export type GetTransactionPriceMutationError = unknown

    export const useGetTransactionPrice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTransactionPrice>>, TError,{data: CustomerTransactionPriceRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTransactionPrice>>,
        TError,
        {data: CustomerTransactionPriceRequestDTO},
        TContext
      > => {

      const mutationOptions = getGetTransactionPriceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    